import React from 'react';
import './Projects.css';

export default function Projects() {
  return (
    <div className="projects-container">
      <div className="projects-hero">
        <h1 className="projects-title">Project Gallery</h1>
        <p className="projects-subtitle">Showcasing Innovation & Technical Excellence</p>
      </div>

      <div className="projects-build-notice">
        <div className="build-icon">🚧</div>
        <h2 className="build-title">Currently Building Something Amazing</h2>
        <div className="build-content">
          <p className="build-description">
            I'm currently developing an interactive project gallery that will showcase my portfolio of work.
            This gallery will feature:
          </p>

          <ul className="build-features">
            <li>
              <span className="feature-icon">🎨</span>
              <div className="feature-text">
                <strong>Interactive Visual Gallery</strong>
                <p>Dynamic project cards with hover effects and smooth transitions</p>
              </div>
            </li>
            <li>
              <span className="feature-icon">🔍</span>
              <div className="feature-text">
                <strong>Filterable Projects</strong>
                <p>Filter by technology stack, project type, and industry</p>
              </div>
            </li>
            <li>
              <span className="feature-icon">📱</span>
              <div className="feature-text">
                <strong>Responsive Design</strong>
                <p>Optimized viewing experience across all devices</p>
              </div>
            </li>
            <li>
              <span className="feature-icon">🎯</span>
              <div className="feature-text">
                <strong>Detailed Case Studies</strong>
                <p>In-depth project breakdowns with challenges, solutions, and results</p>
              </div>
            </li>
            <li>
              <span className="feature-icon">🔗</span>
              <div className="feature-text">
                <strong>Live Demos & Code</strong>
                <p>Direct links to live projects and GitHub repositories</p>
              </div>
            </li>
          </ul>

          <div className="build-timeline">
            <p className="timeline-text">
              <strong>Expected Completion:</strong> Coming Soon
            </p>
            <p className="timeline-note">
              In the meantime, feel free to <a href="/contact">contact me</a> to discuss my work
              or view my <a href="https://github.com/RaulCo4" target="_blank" rel="noopener noreferrer">GitHub</a> for code samples.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
